'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponderByIdAndType = getResponderByIdAndType;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getResponderByIdAndType(_ref) {
  var responders = _ref.responders,
      senderId = _ref.senderId,
      senderType = _ref.senderType;

  return (0, _getIn2.default)([senderType, '' + senderId], responders);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/responders/operators/getResponderByIdAndType.js
// module id = 416
// module chunks = 2 3